<div class="personal-main-container">
  <div class="personal-main-nav-bar box">
    <div class="personal-main-nav-bar-title">ساخت پکیج</div>
    <div class="personal-main-back img-holder" (click)="back()">
      <img src="assets/general/back-blue.svg" />
    </div>
  </div>
  <div class="personal-main-top box">
    <div class="wrapper">
      <p class="primary">اطلاعات پکیج</p>
      <div class="input-wrapper">
        <input
          type="text"
          [(ngModel)]="packageTitle"
          (ngModelChange)="activeBtn()"
          placeholder="نام پکیج را وارد کنید..."
        />
      </div>
      <div *ngIf="selectdFoods">
        <div
          class="input-wrapper"
          (click)="editFood(d[0], d[1])"
          *ngFor="let d of selectdFoods"
        >
          <p class="select">{{ d[0].name }}</p>
          <p class="unit primary-unit">{{ d[1] }} {{ getFoodUnit(d[0]) }}</p>
        </div>
      </div>
    </div>
    <div class="addBtn" (click)="showSearch()">
      <div class="inner">
        <div class="icon">
          <img src="assets/plan/plus.svg" alt="" />
        </div>
        <p>افزودن غذا به پکیج</p>
      </div>
    </div>
    <div class="wrapper" style="padding-bottom: 96px">
      <p>جدول ارزش غذایی</p>
      <div
        class="input-wrapper"
        *ngFor="let name of foodFactsNames; let i = index"
      >
        <p class="unit">{{ foodFactsAmount[i] }} {{ foodFactsUnits[i] }}</p>
        <p class="select">
          {{ name }}
        </p>
      </div>
    </div>
    <div class="navbar-bottom">
      <div
        class="success"
        *ngIf="!edit"
        (click)="submit()"
        [ngClass]="{ blue: ready }"
      >
        ثبت
      </div>
      <div
        class="success"
        *ngIf="edit"
        (click)="update()"
        [ngClass]="{ blue: ready }"
      >
        ثبت
      </div>

      <div class="cancel" *ngIf="!edit" (click)="cancel()">انصراف</div>
      <div class="cancel" *ngIf="edit" (click)="delete()">حذف</div>
    </div>
  </div>
</div>
<app-personal-package-search
  *ngIf="displaySearch"
  (closeSearch)="closeSearch($event)"
  [show]="show"
></app-personal-package-search>
